define(
({
  "select_shipping_method": "Szállítási mód kiválasztása"
})
);
